export class QuestionTokens {
    constructor(public org: string) {

    }

    replace(rawString: string) {
        return rawString.replace('{{org}}', this.org);
    }
}